import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './styles.scss';

const FormRow = ({ className, hasError, align, children, as: Tag = 'div', ...rest }) => (
    <Tag className={classNames(className, styles.root, { [styles.right]: align === 'right' })} {...rest}>
        {children}
    </Tag>
);

FormRow.propTypes = {
    className: PropTypes.string,
    hasError: PropTypes.bool,
    children: PropTypes.any,
    as: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType, PropTypes.func]),
    align: PropTypes.oneOf(['left', 'right']),
};

FormRow.defaultProps = {
    hasError: false,
};

export default FormRow;
